exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "covance-ag-grid ::ng-deep .ag-header {\n  height: 1px !important;\n  border-width: 0;\n}\n\ncovance-ag-grid ::ng-deep .ag-body {\n  top: 1px !important;\n}\n\ncovance-filter {\n  flex-shrink: 0;\n  padding-bottom: 10px;\n}\n\n.micro-legend {\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n", ""]);

// exports
